<template>
  <footer id="footer">
    <div class="container">
      <share-buttons></share-buttons>
      <bottom-nav-secondary></bottom-nav-secondary>
      <div class="copyright">&copy; {{ new Date().getFullYear() }} Øptimus Consulting, LLC. All rights reserved</div>
      <div class="copyright">Design, development and statistical model by Øptimus Consulting, LLC</div>
    </div>
  </footer>
</template>

<script>
import BottomNavSecondary from './BottomNavSecondary'
import ShareButtons from '@/components/common/ShareButtons'

const name = 'fc_footer'

const components = {
  BottomNavSecondary,
  ShareButtons
}

export default {
  name,
  components
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue